export default "__VITE_ASSET__5Slqrf69__"